const getZendeskRootDiv = (): HTMLElement | undefined | null => {
  const launcherIframe = document.querySelector('iframe#launcher');

  if (launcherIframe) {
    let parent = launcherIframe.parentElement;
    let rootDiv = null;
    while (parent && parent !== document.body) {
      if (parent.parentElement === document.body && parent.tagName === 'DIV') {
        rootDiv = parent;
        break;
      }
      parent = parent.parentElement;
    }
    return rootDiv;
  }
};

export const cleanUpZendesk = () => {
  if (window?.zE) {
    window.zE('webWidget', 'hide');
    window.zE('webWidget', 'reset');
    window.zE('webWidget', 'logout');
  }
  
  delete window?.zE;
  delete window?.zEACLoaded;
  delete window?.zESettings;
  delete window?.zEWebpackACJsonp;
  delete window?.zEmbed;

  const zendeskScript = document.querySelector('script[id="ze-snippet"]');
  if (zendeskScript) {
    zendeskScript.remove();
  }

  const zendeskIframe = document.querySelector('iframe[data-product="web_widget"]');
  if (zendeskIframe) {
    zendeskIframe.remove();
  }

  const rootDiv = getZendeskRootDiv();
  if (rootDiv) {
    rootDiv.remove();
  }
};
